'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import ClosureAnnouncement from './homepage/ClosureAnnouncement';

export default function AnnouncementBar() {
  const [isModalOpen, setModalOpen] = useState(false);

  return (
    <>
      {/* Announcement Bar */}
      <div
        className="cursor-pointer bg-yellow-100 py-2 text-center text-yellow-800"
        onClick={() => setModalOpen(true)}
      >
        Important: Mayes Auto Detailing Is Closing June 30 – Click for Details
      </div>

      {/* Navbar placeholder: insert your existing Navbar component below */}
      {/* <Navbar /> */}

      {/* Modal Overlay */}
      {isModalOpen && (
        <div className="bg-opacity-50 fixed inset-0 z-50 flex items-center justify-center bg-black">
          <div className="relative mx-4 max-h-[90vh] w-full max-w-3xl overflow-y-auto rounded-2xl bg-white p-6 shadow-xl">
            {/* Close Button */}
            <button
              className="absolute top-4 right-4 text-2xl text-gray-600 hover:text-gray-900"
              onClick={() => setModalOpen(false)}
              aria-label="Close announcement modal"
            >
              &times;
            </button>

            {/* Modal Content */}
            <ClosureAnnouncement />
          </div>
        </div>
      )}
    </>
  );
}
